<template>
  <v-dialog
    v-model="dialog"
    :width="width ? width : 600"
    :content-class="scrollDisable ? 'scrollDisable' : ''"
    :persistent="persistent"
  >
    <template v-slot:activator="{}">
      <slot v-if="!externalActivator" name="activator">
        <BaseButton
          v-if="modalType ? modalType === 'create' : !edit"
          @click="openModal"
          :text="textAssign.button.open"
          default_icon="button-add"
          :disabled="disabled"
          :minimalize="minimalize"
        />
        <EditBtn
          v-else-if="modalType ? modalType === 'edit' : edit"
          :openModal="openModal"
          :disabled="disabled"
        />
        <ButtonShow v-else-if="modalType === 'show'" :openModal="openModal" :disabled="disabled" />
      </slot>
    </template>
    <transition :duration="150">
      <div v-if="dialog" class="modal" :class="{ center }" :style="cssVars">
        <CloseModalBtn :closeModal="closeModal" />
        <h4
          class="f30"
          v-if="
            (modalType ? modalType === 'create' : !edit)
              ? textAssign.title.create
              : (modalType ? modalType === 'edit' : edit)
              ? textAssign.title.edit
              : textAssign.title.show
          "
        >
          {{
            (modalType ? modalType === 'create' : !edit)
              ? textAssign.title.create
              : (modalType ? modalType === 'edit' : edit)
              ? textAssign.title.edit
              : textAssign.title.show
          }}
        </h4>

        <v-form
          class="form gap5"
          ref="form"
          lazy-validation
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <slot></slot>
          <div class="mt-3" v-if="empty ? false : modalType !== 'show'">
            <slot name="submit">
              <BaseButton
                v-if="textAssign.button"
                type="submit"
                :text="
                  (modalType ? modalType === 'create' : !edit)
                    ? textAssign.button.create
                      ? textAssign.button.create
                      : localStorage.translations.pages.common.buttons.create
                    : (modalType ? modalType === 'edit' : edit)
                    ? textAssign.button.save
                      ? textAssign.button.save
                      : localStorage.translations.pages.common.buttons.sohranit
                    : null
                "
                default_icon="button-save"
              />
            </slot>
          </div>
        </v-form>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import CloseModalBtn from 'components/CloseModalBtn'
import EditBtn from 'components/EditBtn'
import ButtonShow from 'components/ButtonShow'

export default {
  name: 'TemplateModal',
  components: { CloseModalBtn, EditBtn, ButtonShow },
  props: {
    width: [String, Number],
    text: Object,
    sendFunction: Function,
    openFunction: Function,
    edit: Boolean,
    group: { modalType: Object },
    center: {
      type: Boolean,
      default: true
    },
    externalActivator: Boolean,
    empty: Boolean,
    scrollDisable: Boolean,
    modalType: {
      // create, edit, show
      modalType: String,
    },
    disabled: Boolean,
    persistent: Boolean,
    background: { type: String, default: '#ffffff' },
    padding: { type: String, default: '50px 40px 35px' },
    borderRadius: { type: String, default: '8px' },
    minimalize: Boolean,
    disableAutoClose: Boolean,
  },
  data() {
    return {
      valid: true,
      dialog: false,
      textDefault: {
        button: {
          open: '',
          create: '',
          save: '',
        },
        title: {
          create: '',
          edit: '',
          show: '',
        },
      },
    }
  },
  mounted() {
    Object.assign({}, this.textDefault, this.text)
  },
  computed: {
    textAssign() {
      return Object.assign({}, this.textDefault, this.text)
    },
    cssVars() {
      return {
        '--background': this.background,
        '--padding': this.padding,
        '--border-radius': this.borderRadius,
      }
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$refs.form.resetValidation()
        // if (this.$parent.defaultData()) {
        //     this.$parent.defaultData()
        // }
      }
    },
  },
  methods: {
    openModal(group) {
      if (this.openFunction)
        this.openFunction()
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
      this.valid = true
    },
    validate() {
      return this.$refs.form.validate()
    },
    onSubmit() {
      if (this.$refs.form.validate())
        if (this.sendFunction) {
          this.sendFunction()
          if (!this.disableAutoClose) this.closeModal()
        }
    }
  },
}
</script>

<style lang="scss" scoped>
.modal {
  border-radius: var(--border-radius);
  box-shadow: 0 30px 30px rgba(39, 127, 175, 0.2);
  text-align: start;
  padding: var(--padding);
  background: var(--background);
  position: relative;
  display: grid;
  row-gap: 32px;
  .form {
    display: grid;
    grid-template-columns: 1fr;
    flex-direction: column;
    justify-content: flex-start;
    justify-items: flex-start;
    align-items: flex-start;
    & > :deep() *:not(:last-child) {
      width: 100%;
    }
  }
  &.center {
    h4 {
      text-align: center;
    }
    .form {
      justify-content: center;
      justify-items: center;
    }
  }
}
</style>
